import http from '../http'

// Fetches a short-lived, ownership-gated ticket for the live-class realtime socket
// (ADR 0007, Phase 4). socket-server used to accept initiate/end-course from anyone
// (spoofable); it now verifies this ticket in the handshake. Authenticated by the BFF
// via the shared session cookie (no Token header); the double-submit CSRF token is
// added by the shared http instance for this POST.
export class SocketTicketController {
    #endpoint
    #fingerprint

    constructor (endpoint, fingerprint) {
        this.#endpoint = endpoint
        this.#fingerprint = fingerprint
    }

    // Resolve to the ticket string, or null if the request fails — a null lets the
    // caller still connect (during rollout the server allows ticketless calls; once
    // enforcement is on such a connection simply can't emit, rather than crash).
    getTicket () {
        const headers = {}
        // The backend gates the ticket on the same device the main app registered.
        if (this.#fingerprint) {
            headers['X-Device-Fingerprint'] = this.#fingerprint
        }

        return http.post(this.#endpoint, {}, { headers })
            .then(res => res.data.ticket)
            .catch(error => {
                console.log(error)
                return null
            })
    }

    // Build the socket.io `auth` provider. socket.io invokes this before EVERY
    // (re)connect, so each attempt — including reconnections long after the 60s ticket
    // expired — carries a freshly minted ticket; a static `auth: { ticket }` would break
    // every reconnect once enforcement is on. A null ticket yields `{}` (ticketless):
    // allowed while enforcement is off, refused once on, never stuck on a dead ticket.
    authProvider () {
        return cb => {
            this.getTicket()
                .then(ticket => cb(ticket ? { ticket } : {}))
                .catch(() => cb({}))
        }
    }
}
